<template>
  <div>
    <el-row>
      <el-col :span="5">
        <el-input placeholder="请输入SN" v-model="sn"></el-input>
      </el-col>
      <el-col :span="5">
        <el-button @click="print">打印</el-button>
      </el-col>
    </el-row>
    <el-row v-if="printData.preview_image">
      <el-image style="width: 400px;" :src="'data:image/jpeg;base64,'+printData.preview_image"></el-image>
    </el-row>
  </div>
</template>

<script>
import {nanoid} from "nanoid";

export default {
  name: "TestPrint",
  data() {
    return {
      sn: '',
      printData: {}
    }
  },
  methods: {
    async print() {
      this.printData = await this.$http('devTestService.testPrint', {sn: this.sn})

      this.printData.request_id = nanoid()
      await this.$http(process.env.VUE_APP_PRINT_URL, this.printData, false).then(data => {
        this.$message.error('打印请求已发送到打印机');
      }, errMsg => {
        this.$message.error('调用打印机失败：' + errMsg);
      });


    }
  }
}
</script>

<style scoped>

</style>